import {cache} from 'locache';
import request from 'superagent';

export const addToShortlist = (state, id) => {
    const shortlist = cache('shortlist').get() || {};
    if (!shortlist[id]) {
        shortlist[id] = 'set';
    }
    cache('shortlist').set(shortlist);
    return state.set('shortlist', shortlist);
};

export const removeFromShortlist = (state, id) => {
    const shortlist = cache('shortlist').get();
    if (shortlist === null) {
        return;
    }
    if (shortlist[id] === 'set') {
        delete shortlist[id];
    }
    cache('shortlist').set(shortlist);
    return state.set('shortlist', shortlist);
};

export const getShortlistDataAjax = (shortlist) => {
    const nodes = Object.entries(shortlist).map(([key, value]) => {
        return value === 'set' ? key : null;
    }).join(',');
    return request('/umbraco/api/ShortlistApi/GetShortlistData')
        .query({
            nodes
        });
};

export const setShortlistData = (state, shortlistData) => {
    return state.set('shortlistData', shortlistData);
};


export const showToast = (removed = false) => {
    const toast = document.getElementsByClassName('shortlist-toast');

    if (!toast.length) {
        return;
    }
    toast[0].innerText = (removed ? 'Removed from shortlist' : 'Added to shortlist');
    toast[0].classList.add('--open');

    setTimeout((toast) => {
        toast.classList.remove('--open');
    }, 3000, toast[0]);
};
